import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

// import ModalButton from '../../components/ModalButton';
import SignUpForm from '../../components/SignUpForm';
import StateMap from '../../components/StateMap';
import GuideSectionCallouts from '../../components/GuideSectionCallouts';


export default class Home extends Component {

  selectGuidePage(page) {
    this.props.setGuidePage(page);
    window.scrollTo(0, 0);
  }

  render() {

    let HomeMapLinks = (
      <div className="Home__map__links">
        <h2>Legal Marijuana By State</h2>
        <Link to="/state/alaska">Alaska</Link>
        <Link to="/state/california">California</Link>
        <Link to="/state/colorado">Colorado</Link>
        <Link to="/state/maine">Maine</Link>
        <Link to="/state/massachusetts">Massachusetts</Link>
        <Link to="/state/nevada">Nevada</Link>
        <Link to="/state/oregon">Oregon</Link>
        <Link to="/state/washington">Washington</Link>
      </div>
    )

    return (
      <div className="Home">
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: this.props.route.meta.meta_about },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <div className="banner__wrapper">
          <div className="banner banner--green">
            <div className="content_wrapper">
              <div className="banner__copy">
                Want to learn how to grow marijuana?
              </div>
              <div className="banner__cta">
                <Link to="/guide-to-gardening/should-i-grow-marijuana">View Our Guide</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="Home__map">
          <h1>One Nation. Legalizing.</h1>
          <StateMap />
          <div className="Home__map__legend">
            <ul>
              <li className="Home__map__legend__item-1">Recreational</li>
              <li className="Home__map__legend__item-2">Medical</li>
              <li className="Home__map__legend__item-3">Decriminalized</li>
            </ul>
          </div>
        </div>
       
        <div className="Home__signup">
          <h2>Join Our Mailing List</h2>
          <p>Keep up to date with all the latest content and information regarding legal marijuana in the United States. </p>
          <SignUpForm />
        </div>

        <div className="Home__guide">
          <h2>Jane's Guide to Gardening</h2>
          <p>
          Jane’s Guide to Gardening has all the information you need to grow marijuana. It is written for the curious individual looking to plant their first seed. It is focused on growing indoors in soil, although many of the principles will apply to other methods. 
          </p>
          <p>
          New growers should begin by reading <Link to="guide-to-gardening/should-i-grow-marijuana">Should I Grow Marijuana?</Link>
          </p>
          <GuideSectionCallouts />
        </div>
        <div className="Home__about">
          <h2>About Jane's Colony</h2>
          <p>Jane’s Colony is committed to providing resources to help you learn about marijuana, understand your rights, discover new strains and cultivate cannabis at home. </p>
          <img src="https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/janes_colony_icon.png" />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/Home/Home.js